<template lang="pug">
  .component-reservation-list-filter-form.filter-form
    .entity-filters(v-if="$is('entity-filter')")
      select(v-model="search.status", v-on:change="filterReportings").medium-5
        option(value="" selected="") All statuses
        option(value="PENDING_REVIEW") Pending Review
        option(value="CONFIRMED") Confirmed
        option(value="RESOLVED") Resolved
        option(value="VOIDED") Voided
    .row(v-else)
      .columns
        label Driver
        SearchEntity(entity="drivers", v-model="search.driver_id")
      .columns
        label Vehicle
        selectize-vehicle(@optionSelected="setVehicleId",  @optionRemoved="unsetVehicleId" :disabledSlot="0")
      .columns
        label Reporting types
        select(v-model="search.reporting_type_id")
          option(:value="null") All types
          option(v-for="reportingType in reportingTypes", :value="reportingType.id") {{reportingType.name}}
      .columns
        label Status
        select(v-model="search.status")
          option(value="" selected="") All statuses
          option(value="PENDING_REVIEW") Pending Review
          option(value="CONFIRMED") Confirmed
          option(value="RESOLVED") Resolved
          option(value="VOIDED") Voided
      .columns
        a.fa.fa-angle-double-down.fa-2x(v-on:click="filterReportings")
</template>
<script type="text/babel">
import KeplerBackofficeSdk from 'src/lib/kepler/backoffice'
import DatePicker from 'components/structure/DatePicker'

import SearchInputForm from 'components/structure/ui/filters/SearchInputForm'
import SelectizeDriver from '../lists/selectize/SelectizeDriver'
import SelectizeVehicle from '../lists/selectize/SelectizeVehicle'
import SearchEntity from "../SearchEntity.vue";

export default {
  name: 'ReportingListForm',
  components: {
    SearchEntity,
    SelectizeVehicle,
    SelectizeDriver,
    KeplerBackofficeSdk,
    DatePicker,
    SearchInputForm,
  },
  data() {
    return {
      vehicles: [],
      reportingTypes: [],
      search: {
        driver_id: null,
        vehicle_id: null,
        reporting_type_id: null,
        status: null
      }
    }
  },

  created() {
    this.getReportingTypes()
  },
  methods: {
    setDriverId(driver) {
      this.search.driver_id = driver.id
    },
    setVehicleId(vehicle) {
      this.search.vehicle_id = vehicle.id
    },
    filterReportings() {
      this.$emit('filterReportings', this.search)
    },
    unsetDriverId() {
      this.search.driver_id = null
    },
    unsetVehicleId() {
      this.search.vehicle_id = null
    },
    getReportingTypes() {
      KeplerBackofficeSdk.reportings.list(1, -1,).types((data) => {
        this.reportingTypes = data
      })
    }
  },
  computed: {},
  props: ['type'],
}
</script>
<style lang="sass" rel="stylesheet/sass">
.toggle-select
  display: none

  .toggle-input
    display: none
</style>



// WEBPACK FOOTER //
// ReportingListForm.vue?06ec7480